// eslint-disable-next-line no-useless-escape
const re = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export function getImageUrl(x, type) {
  if (x == null) {
    return x;
  }
  if (isUrl(x)) {
    return x;
  }
  if (type && type === "ATTRIBUTE") {
    return `https://s3.us-east-2.amazonaws.com/ff-attribute-icons/${x}`;
  }
  return `https://s3.us-east-2.amazonaws.com/ff-large-upc-webp2/${x}.jpg`;
}

function isUrl(x) {
  return re.test(x);
}
